// @flow

export type GoogleAnalyticTrackingId = string;

// -----------------------------------------------------------------------------------------------------------------
// Value store
// -----------------------------------------------------------------------------------------------------------------

let gaTrackingId: ?GoogleAnalyticTrackingId;


// -----------------------------------------------------------------------------------------------------------------
// Main function
// -----------------------------------------------------------------------------------------------------------------

function getGoogleAnalyticsTrackingId(): ?GoogleAnalyticTrackingId {

  if (!gaTrackingId) {
    gaTrackingId = (process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID: ?GoogleAnalyticTrackingId);
  }

  if (!gaTrackingId) {
    const err = new Error('Missing Google Analytics Tracking Id');

    if ('production' === process.env.NODE_ENV) {
      const Raven = require('../../modules/raven-cdn');
      Raven.captureException(err);
      return;
    }

    throw err;
  }

  return gaTrackingId;

}


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default getGoogleAnalyticsTrackingId;



// WEBPACK FOOTER //
// ./src/analytics/google-analytics/getGoogleAnalyticsTrackingId.js